import { render, staticRenderFns } from "./ModernUi.vue?vue&type=template&id=6cdb825d&scoped=true"
import script from "./ModernUi.vue?vue&type=script&lang=js"
export * from "./ModernUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdb825d",
  null
  
)

export default component.exports